import { render, staticRenderFns } from "./SysTypeDrawer.vue?vue&type=template&id=aab331e0&scoped=true&"
import script from "./SysTypeDrawer.vue?vue&type=script&lang=js&"
export * from "./SysTypeDrawer.vue?vue&type=script&lang=js&"
import style0 from "./SysTypeDrawer.vue?vue&type=style&index=0&id=aab331e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aab331e0",
  null
  
)

export default component.exports